import { render, staticRenderFns } from "./InternationalTraffic.vue?vue&type=template&id=dc859816&scoped=true&"
import script from "./InternationalTraffic.vue?vue&type=script&lang=js&"
export * from "./InternationalTraffic.vue?vue&type=script&lang=js&"
import style0 from "./InternationalTraffic.vue?vue&type=style&index=0&id=dc859816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc859816",
  null
  
)

export default component.exports